export var PenumbraState;
(function (PenumbraState) {
    /* error is present */
    PenumbraState["Failed"] = "Failed";
    /* no action has been taken */
    PenumbraState["Present"] = "Present";
    /* approval request pending */
    PenumbraState["RequestPending"] = "RequestPending";
    /* request for approval satisfied */
    PenumbraState["Requested"] = "Requested";
    /* connection attempt pending */
    PenumbraState["ConnectPending"] = "ConnectPending";
    /* connection successful and active */
    PenumbraState["Connected"] = "Connected";
    /* disconnect was called to release approval */
    PenumbraState["Disconnected"] = "Disconnected";
})(PenumbraState || (PenumbraState = {}));
